import { Observable } from 'rxjs';
import { htmlFromDom } from '../../helpers/dom/htmlFromDom';
import { cleanHtmlToDom } from '../../helpers/dom/htmlToDom';
import { replaceAllChildren } from '../../helpers/dom/node';
import { markdownFromDom } from '../../helpers/markdown/markdownFromDom';
import { markdownToDom } from '../../helpers/markdown/markdownToDom';
import { createConnectingService } from '../base/connectingService';
import { BaseService } from '../base/service';
import { HtmlService } from '../html/htmlService';
import { MarkdownService } from '../rich/markdownService';
import { ElementService } from './elementService';

export function createElementMarkdownService(
  element$: Observable<Element | null>,
  htmlService: HtmlService,
): MarkdownService {
  return createConnectingService<Element, MarkdownService>(
    element$,
    () => new HtmlMarkdownService(htmlService),
    element => new ElementMarkdownService(element, htmlService),
  );
}

class ElementMarkdownService extends ElementService<Element> implements MarkdownService {
  get markdown() {
    return markdownFromDom(this.element);
  }

  setMarkdown(markdown: string) {
    const fragment = markdownToDom(this.document, markdown);
    replaceAllChildren(this.element, fragment);
  }
}

class HtmlMarkdownService extends BaseService implements MarkdownService {
  constructor(htmlService: HtmlService) {
    super(htmlService);

    this.htmlService = htmlService;
  }

  private readonly htmlService: HtmlService;

  get markdown() {
    const { cleanHtml } = this.htmlService;
    return cleanHtmlToDom(cleanHtml, parentNode => markdownFromDom(parentNode));
  }

  setMarkdown(markdown: string) {
    const cleanHtml = htmlFromDom(document => markdownToDom(document, markdown));
    this.htmlService.setCleanHtml(cleanHtml);
  }
}
